var render, staticRenderFns
import script from "./base.component.vue?vue&type=script&lang=js"
export * from "./base.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddd0afa0')) {
      api.createRecord('ddd0afa0', component.options)
    } else {
      api.reload('ddd0afa0', component.options)
    }
    
  }
}
component.options.__file = "src/components/base.component.vue"
export default component.exports